
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analyzer/[city]/map",
      function () {
        return require("private-next-pages/analyzer/[city]/map.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analyzer/[city]/map"])
      });
    }
  